import React from 'react';

import CountryInfo from '../CountryInfo';

const CRISIS_FUND_SECTION = {
    title: 'Coronavirus Crisis Fund',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">
                The Fund will include:
            </p>
            <ul>
                <li>Liquidity by way of loans and loan guarantees</li>
                <li>
                    Help with shortening working hours for staff and deferring
                    taxes
                </li>
                <li>
                    Aid for one-person and family-owned enterprises, and the
                    tourism and cultural sectors
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Austria Readies $4.4 Billion Coronavirus Crisis Fund for Economy',
            url: 'https://www.msn.com/en-us/money/companies/austria-readies-dollar44-billion-coronavirus-crisis-fund-for-economy/ar-BB11b7gb',
        },
        {
            title: 'Austria Launches Coronavirus Aid, Ready to Help Support Companies',
            url: 'https://www.nytimes.com/reuters/2020/03/14/world/europe/14reuters-health-coronavirus-austria.html',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Austria',
    lastUpdated: 'March 17, 2020',
    introSection: (
        <p>Austria has announced a $4.4 billion Coronavirus Crisis Fund.</p>
    ),
    sections: [CRISIS_FUND_SECTION],
};

const AustriaInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default AustriaInfo;
